import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { show as getPart } from "MODULES/parts/actions";
import { Map } from "immutable";
import { loadRecord } from "MODULES/shared/decorators";
import BackToPart from "MODULES/parts/components/shared/BackToPart";
import {
  FilterSelect,
  Pagination,
  SearchFilter,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { Search } from "MODULES/shared/components";
import {
  INCOMING_QUOTE_FILTER_TAGS,
  INCOMING_QUOTE_FILTERS
} from "MODULES/IncomingQuotes/Search/IncomingQuotes";
import Table from "./Table";
import { incomingQuotesPagination } from "../../pagination";
import CreateMultiVendorQuote from "./CreateMultiVendorQuote/CreateMultiVendorQuote";
import Create from "./Create/Create";

export function IncomingQuoteLineItems({ part }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [vendorModalOpen, setVendorModalOpen] = useState(false);
  return (
    <Search search={incomingQuotesPagination} syncWithUrl>
      {searchProps => (
        <div>
          <BackToPart part={part} />
          <div
            className="form-group form-group-searchbar has-feedback has-feedback-left"
            style={{ margin: "-15px -30px 30px -30px" }}
          >
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by typing a Company Name..."
              />
              <FilterSelect
                {...searchProps}
                filters={INCOMING_QUOTE_FILTERS.filter(
                  f => !f.exclude_parts_view
                )}
                right
              />
              <div className="input-group-btn">
                <button
                  onClick={() => setModalOpen(true)}
                  className="btn btn-primary pull-right"
                  type="button"
                >
                  <i className={`fa fa-fw fa-plus`} />
                  Create Quote
                </button>
              </div>
              <div className="input-group-btn">
                <button
                  onClick={() => setVendorModalOpen(true)}
                  className="btn btn-success pull-right"
                  type="button"
                >
                  <i className={`fa fa-fw fa-plus`} />
                  Create Multi-Vendor Quote
                </button>
              </div>
            </div>
          </div>
          <Create open={modalOpen} close={() => setModalOpen(false)} />
          <CreateMultiVendorQuote
            open={vendorModalOpen}
            close={() => setVendorModalOpen(false)}
          />
          <TitleWithFilters
            {...searchProps}
            title="Incoming Quote History"
            filters={INCOMING_QUOTE_FILTER_TAGS}
          />
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

IncomingQuoteLineItems.propTypes = {
  part: PropTypes.instanceOf(Map).isRequired
};

export default connect(state => ({
  part: state.partDetail.get("part")
}))(
  loadRecord({
    reducer: "partDetail",
    name: "part",
    action: getPart
  })(IncomingQuoteLineItems)
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/IncomingQuoteLineItems/IncomingQuoteLineItems.jsx